export default "__VITE_PUBLIC_ASSET__9b9ef570__"